import EnterpriseSWIcon from "../../assets/product-list-assets/gbe-1u-2510.svg";
import type { ProductListGroup } from "../../types";

export const productListSwitchingProfessional: ProductListGroup = {
  id: "productListSwitchingProfessional",
  title: "productListGroup.switchingProfessional.title",
  icon: {
    src: EnterpriseSWIcon,
    width: 24,
    height: 24,
  },
};
